import "./App.css";
import Routes from "./router";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
// import store from "./store";
import store from "./store/store";

function App() {
  return (
      <Provider store={store}>
        <Toaster containerStyle={{ zIndex: 999999 }} />
        <Routes />
      </Provider>
  );
}

export default App;
